import { render, staticRenderFns } from "./plainTextStyle.vue?vue&type=template&id=4ff5eb8a&"
import script from "./plainTextStyle.vue?vue&type=script&lang=ts&"
export * from "./plainTextStyle.vue?vue&type=script&lang=ts&"
import style0 from "./plainTextStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports